export const ICONS = {
    edit_action:require('../assets/images/edit.png'),
    delete_action:require('../assets/images/icons8-delete-32.png'),
    clone_action:require('../assets/images/clone-figure.png'),
    view_action:require('../assets/images/view-details.png'),
    whatsapp:require('../assets/images/whatsapp.png'),
    ivr:require('../assets/images/ivr.png'),
    ivr_marketing : require('../assets/images/ivr-marketing.png')
} 